import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CollectionsList from "./CollectionsList";
import RecipesList from "./RecipesList";
import { CreatorProductsWrapper, EmptyProducts } from "./styled";
import {
  getCollections,
  getRecipes,
  isCollectionsLoading,
  isRecipesLoading,
} from "../../../store/recipesReducer/recipesSelectors";
import {
  getCreatorCollectionsAndRecipeData,
  setCreatorCollections,
  setCreatorRecipes,
} from "../../../store/recipesReducer/recipesActions";
import { Spinner } from "../../../styles/App.styled";
import { getOwner, getUser } from "store/userReducer/userSelectors";

const Products = () => {
  const [isAllCollections, setIsAllCollections] = useState(false);
  const [allCollectionsLoaded, setAllCollectionsLoaded] = useState(false);
  const dispatch = useDispatch();
  const currentUser = useSelector(getUser);
  const currentOwner = useSelector(getOwner);
  const userId = currentUser.id || currentOwner.id;
  const collections = useSelector(getCollections);
  const [isLoaded, setIsLoaded] = useState(false);
  const recipes = useSelector(getRecipes);
  const recipesNextPage = recipes.next;
  const _isCollectionsLoading = useSelector(isCollectionsLoading);
  const _isRecipesLoading = useSelector(isRecipesLoading);
  const hasMoreCollections = collections.count > 10;
  const isEmpty = collections.count === 0 && recipes.count === 0 && !_isRecipesLoading && !_isCollectionsLoading;

  useEffect(() => {
    dispatch(getCreatorCollectionsAndRecipeData(userId)).then(() => setIsLoaded(true));
  }, []);

  const showCollections = (full) => {
    if (full && !allCollectionsLoaded) {
      setIsAllCollections(true);
      setAllCollectionsLoaded(true);
      dispatch(setCreatorCollections({ id: userId, full }));
    } else {
      setIsAllCollections(full);
    }
  };

  const fetchNextRecipes = () => {
    if (recipesNextPage) {
      const page = recipesNextPage.match(/page=([^&]*)/)[1];
      dispatch(setCreatorRecipes({ id: userId, page }));
    }
  };

  const displayedCollections = isAllCollections ? collections?.results : collections?.results?.slice(0, 10);
  const emptyMessageName = currentUser.show_business_name
    ? currentUser.business_name
    : `${currentUser.first_name} ${currentUser.last_name}`;
  if (!isLoaded || _isCollectionsLoading) {
    return <Spinner />;
  } else {
    return (
      <CreatorProductsWrapper>
        {isEmpty ? (
          <EmptyProducts>{`${emptyMessageName} hasn’t published any recipes yet - check back soon!`}</EmptyProducts>
        ) : (
          <>
            <CollectionsList
              collections={displayedCollections}
              userId={userId}
              isLoading={_isCollectionsLoading}
              hasMore={hasMoreCollections}
              showMore={() => showCollections(true)}
              showLess={() => showCollections(false)}
              isAll={isAllCollections}
            />
            {recipes.count && (
              <RecipesList
                recipes={recipes.results}
                userId={userId}
                isLoading={_isRecipesLoading}
                fetchNextRecipes={fetchNextRecipes}
                nextPage={recipesNextPage}
              />
            )}
          </>
        )}
      </CreatorProductsWrapper>
    );
  }
};

export default Products;
